const FONTS = {
  REGULAR: '"Open Sans Regular", Helvetica, Arial, sans-serif',
  BOLD: '"Open Sans Bold", Helvetica, Arial, sans-serif',
  SEMI_BOLD: '"Open Sans SemiBold", Helvetica, Arial, sans-serif',
  TITLE: '"Open Sans Bold", Helvetica, Arial, sans-serif',
}

const COLORS = {
  black: '#000000',
  greyChateau: '#9BA5AD',
}

const typography = {
  heading: {
    large: {
      fontSize: '34px',
      lineHeight: '46px',
      fontFamily: FONTS.TITLE,
      fontWeight: 700,
      color: COLORS.black,
    },
    small: {
      fontSize: '26px',
      lineHeight: '35px',
      fontFamily: FONTS.TITLE,
      fontWeight: 700,
      color: COLORS.black,
    },
    subheading: {
      fontSize: '18px',
      lineHeight: '27px',
      fontFamily: FONTS.TITLE,
      fontWeight: 700,
      color: COLORS.black,
    },
  },
  copy: {
    title: {
      fontSize: '16px',
      lineHeight: '24px',
      fontFamily: FONTS.BOLD,
      fontWeight: 700,
      color: COLORS.black,
    },
    body: {
      fontSize: '16px',
      lineHeight: '24px',
      fontFamily: FONTS.REGULAR,
      fontWeight: 400,
      color: COLORS.black,
    },
    bodyBold: {
      fontSize: '16px',
      lineHeight: '24px',
      fontFamily: FONTS.BOLD,
      fontWeight: 700,
      color: COLORS.black,
    },
    bodyFaint: {
      fontSize: '16px',
      lineHeight: '24px',
      fontFamily: FONTS.REGULAR,
      fontWeight: 400,
      color: COLORS.greyChateau,
    },
    tiny: {
      fontSize: '14px',
      lineHeight: '21px',
      fontFamily: FONTS.REGULAR,
      fontWeight: 400,
      color: COLORS.black,
    },
    tinyFaint: {
      fontSize: '14px',
      lineHeight: '21px',
      fontFamily: FONTS.REGULAR,
      fontWeight: 400,
      color: COLORS.greyChateau,
    },
    tinyBold: {
      fontSize: '14px',
      lineHeight: '21px',
      fontFamily: FONTS.BOLD,
      fontWeight: 700,
      color: COLORS.black,
    },
  },
  label: {
    fontSize: '14px',
    lineHeight: '16px',
    fontFamily: FONTS.SEMI_BOLD,
    fontWeight: 600,
    color: COLORS.black,
  },
  optional: {
    fontSize: '14px',
    lineHeight: '16px',
    fontFamily: FONTS.REGULAR,
    fontWeight: 400,
    color: COLORS.black,
  },
}

export default typography
